import api from '../lib/api';
import type { Staff } from '../types';

export const authService = {
    getCurrentUser: async () => {
        const response = await api.get<Staff>('/api/v1/auth/me');
        return response.data;
    }
};
